import ReactGA from "react-ga4";

const agencyCreated = () => ReactGA.event({action: "agency_created", category:"Adquisition"})

const gaEvents = {
    eventAgencyCreated: agencyCreated
}

export { gaEvents }
